export enum XmlImportModes {
    Replace = 'REPLACE',
    Update = 'UPDATE',
    Enrich = 'ENRICH'
}
